import { pinwheel } from 'ldrs'

pinwheel.register()

export default defineNuxtPlugin((nuxtApp) => {
})
